import { useContext } from 'react';
import { AppContext } from '../../contexts/context';

import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';
import ErrorIcon from '@mui/icons-material/Error';

export const NfcNotGrantedCard = () => {
  const [ state, dispatch ] = useContext(AppContext);

  const handleGrantClick = () => {
    dispatch({type: 'app/ui/control/nfcGrantCheck', value: true});
  }

  const textSubTitle = {
    denied: "NFC devices blocked",
    prompt: "NFC devices blocked",
  }
  const textContent = {
    denied: "The use of NFC was denied on this device. Open the website settings and grant NFC permission to continue.",
    prompt: "No permission to use NFC on this device. Please grant permission to continue.",
  }

  return (
    <Card sx={{
        border: '1px solid',
        borderColor: '#d50000',
        borderRadius: 5,
        display: "flex",
        flexDirection: "column",
        paddingX: 2,
        boxShadow: "none",
        alignItems: "left",
        justifyContent: "left"
      }}>
      <CardHeader
          avatar={
            <Avatar sx={{ bgcolor: "#fff", padding:0.9 }} aria-label="status_icon">
              <ErrorIcon color={"primary"} sx={{fontSize:50, color: '#d50000'}}/>
            </Avatar>
          }
          title="Important information"
          subheader={textSubTitle[state.nfcPermission]}
          titleTypographyProps={{marginLeft:0, color:"text.primary", variant:"h6", fontWeight: 'normal'}}
      />
      <CardContent sx={{mt:0, pt:0, pb:0}}>
        <Typography variant="body2" color="text.secondary">
          {textContent[state.nfcPermission]}
        </Typography>
      </CardContent>
      { state.nfcPermission === 'prompt'
        ? <CardActions>
            <Button
              color="primary"
              onClick={handleGrantClick}
            >
              Grant permission
            </Button>
          </CardActions>
        : ''
      }
    </Card>
  )
}

export default NfcNotGrantedCard;
